import { render, staticRenderFns } from "./PrintBasketModal.vue?vue&type=template&id=b5131166"
import script from "./PrintBasketModal.vue?vue&type=script&lang=js"
export * from "./PrintBasketModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports